<template>
    <div>
        <kt-row v-if="login_cart_gateway !== true">
            <div class="col col-sm-6 col-lg-4 col-xl-3" v-bind:key="gateway.index" v-for="gateway in gateways" style="text-align: right !important;">
                <kt-panel>
                    <kt-panel-body class="pt-4">
                        <div class=" d-flex d-inline-flex justify-content-between">
                            <div class="btn-group ">
                                <a type="button" class="btn text-left" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <i class="fas fa-ellipsis-h"></i>
                                </a>
                                <div class="dropdown-menu dropdown-menu-right">
                                    <a v-if="gateway.gateway_type === gatewayTypes.PARDAKHTYARI ||
                            gateway.gateway_type === gatewayTypes.DEDICATED"
                                       class="dropdown-item" type="button">
                                        <a
                                                class="col-log-1 "
                                                href="#"
                                                @click="getSign(gateway.id, gateway.gateway_type)"
                                                data-toggle="modal" :data-target="'#gatewayKeyModal' + gateway.id"
                                        >
                                            <div class="btn border-0 w-100 ">
                                                <i
                                                        class="fa fa-key fa-sm px-2 routerLink"
                                                        style=""
                                                        aria-hidden="true"

                                                ></i>
                                                {{ $t('label.key') }}
                                            </div>
                                        </a>
                                    </a>
                                    <button v-if="gateway.status === gatewayStatus.ACTIVE &&
                                gateway.gateway_type === gatewayTypes.PARDAKHTYARI"
                                            class="dropdown-item" type="button">
                                        <div class="col-lg-1 " style="text-align: right !important">
                                            <router-link class="btn  border-0 w-100 " :to="getLink(gateway.id)">
                                                <i
                                                        class="fa fa-certificate fa-sm routerLink"
                                                        style="text-align: right !important"
                                                        :title="$t('panel.profile.nav.namad')"
                                                ></i>
                                                {{$t('panel.profile.nav.namad') }}
                                            </router-link>
                                        </div>
                                    </button>
                                        <div v-if="gateway.gateway_type === gatewayTypes.DEDICATED">
                                            <button v-if="gateway.show_psp_report_to_user" class="dropdown-item"
                                                    type="button">
                                                <div class="col-lg-1">
                                                    <div>
                                                        <router-link class="btn  border-0 w-100 " :to="{
                                                name: 'dedicated_transactions_report',
                                                params: {hashid: gateway.id},
                                                query: {psp: gateway.terminal}
                                             }">
                                                            <i class="fas fa-search-dollar fa-sm routerLink "
                                                               size="9x"></i>
                                                            {{ $t('btn.getTransactionReport') }}
                                                        </router-link>
                                                    </div>
                                                </div>
                                            </button>
                                            <button v-if="gateway.show_statement_report_to_user" class="dropdown-item"
                                                    type="button">
                                                <div class="col-lg-1">
                                                    <router-link class="btn  border-0 w-100  " :to="{
                                                name: 'dedicated_statements_report',
                                                params: {hashid: gateway.id},
                                                query: {psp: gateway.terminal}
                                             }">
                                                        <i class="fas fa-credit-card fa-sm routerLink" size="9x"></i>
                                                        {{ $t('btn.getStatementsReport') }}
                                                    </router-link>
                                                </div>
                                            </button>
                                        </div>
                                </div>
                            </div>
                    </div>
                <div v-if="gateway.gateway_type === gatewayTypes.PARDAKHTYARI && gateway.status === gatewayStatus.ACTIVE
                && (gateway.show_psp_report_to_user || gateway.show_statement_report_to_user)" class="btn-group ">
                    <a type="button" class="btn text-left text-info" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i class="fas fa-chart-line "></i>
                    </a>
                    <div class="dropdown-menu  dropdown-menu-left">
                        <div v-if="gateway.gateway_type === 0 " v-for="item in gateway.terminal" :key="item.id">
                            <button  v-if="gateway.show_psp_report_to_user" class="dropdown-item" type="button">
                                <div class="col-lg-1">
                                    <div >
                                        <router-link class="btn  border-0 w-100 "  :to="{
                                                name: 'transactions-report',
                                                params: {hashid: gateway.id},
                                                query: {psp: item.psp}
                                             }">
                                                        <img v-if="item.psp === 'irankish'"
                                                             :src="`/assets/media/psp/${item.psp}.png`" width="25"
                                                             height="25">
                                                        <img v-else :src="`/assets/media/psp/${item.psp}.svg`"
                                                             width="25" height="25">
                                                        <!--                                    <i class="fas fa-search-dollar fa-sm routerLink " size="9x"></i>-->
                                                        {{ $t('btn.getTransactionReport') }}
                                                    </router-link>
                                                </div>
                                            </div>
                                        </button>
                                        <button v-if="gateway.show_statement_report_to_user" class="dropdown-item"
                                                type="button">
                                            <div class="col-lg-1">
                                                <router-link class="btn  border-0 w-100  "
                                                             :to="statementLink(gateway.gateway_type) + gateway.id">
                                                    <!--                                    <i class="fas fa-credit-card fa-sm routerLink" size="9x"></i>-->
                                                    <img v-if="item.psp === 'irankish'"
                                                         :src="`/assets/media/psp/${item.psp}.png`" width="25"
                                                         height="25">
                                                    <img v-else :src="`/assets/media/psp/${item.psp}.svg`" width="25"
                                                         height="25">
                                                    {{ $t('btn.getStatementsReport') }}
                                                </router-link>
                                            </div>
                                        </button>
                                    </div>
                                </div>
                            <button  v-if="gateway.show_statement_report_to_user && item.psp !== 'saman'" class="dropdown-item" type="button">
                                <div class="col-lg-1">
                                    <router-link class="btn  border-0 w-100  " :to="{
                                                name: 'statements-user',
                                                params: {hashid: gateway.id},
                                                query: {psp: item.psp}
                                    }">
                                        <!--                                    <i class="fas fa-credit-card fa-sm routerLink" size="9x"></i>-->
                                        <img v-if="item.psp === 'irankish'" :src="`/assets/media/psp/${item.psp}.png`" width="25" height="25">
                                        <img v-else :src="`/assets/media/psp/${item.psp}.svg`" width="25" height="25">
                                        {{ $t('btn.getStatementsReport') }}
                                    </router-link>
                                </div>
                            </button>
                        </div>
                        <kt-panel-header-label class="text-center">
                            <!-- Modal -->
                            <div class="modal fade" :id="'gatewayKeyModal' + gateway.id" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                <div class="modal-dialog">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <h5 v-if="gateway.gateway_type === gatewayTypes.PARDAKHTYARI"
                                                class="modal-title" id="exampleModalLabel"
                                            >
                                                {{ $t('label.gateway_sign_key') }} ({{ gateway.title }})
                                            </h5>
                                            <h5 v-else-if="gateway.gateway_type === gatewayTypes.DEDICATED"
                                                class="modal-title" id="exampleModalLabel1"
                                            >
                                                {{ $t('label.dedicated_sign_key') }} ({{ gateway.title }})
                                            </h5>
                                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>
                                        <div class="modal-body">
                                    <textarea
                                            :id="'sign_key' + gateway.id"
                                            class="form-control"
                                            rows="5"
                                            style="resize: none;"
                                            readonly
                                            :value="sign_key"
                                    >
                                    </textarea>
                                            <button type="button" class="btn btn-sm btn-clean btn-icon btn-icon-sm" @click="copy(gateway.id)">
                                                <i class="fa fa-copy"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <span v-if="gateway.logo == null">
                        <img src="/assets/media/image-not-found-small.jpg" class="kt-badge kt-badge--xl" :title="$t('label.image_not_found')"/>
                    </span>
                            <span v-else>
                        <img :src="gateway.logo" class="kt-badge kt-badge--xl" />
                    </span>
                            <kt-panel-header-title class="mt-3 text-dark">
                                {{ gateway.title }}
                            </kt-panel-header-title>
                            <span :class="'kt-badge--'+variant(gateway.status)" class="kt-badge kt-badge--dot mr-1"></span>
                            <span :class="'text-'+variant(gateway.status)">
                        {{ statusStr(gateway.status) }}
                        <i
                                v-if="gateway.rejection_reason && gateway.status == gatewayStatus.REJECTED"
                                class="fa fa-exclamation-triangle"
                                style="color: orangered!important; cursor: pointer"
                                aria-hidden="true"
                                data-toggle="tooltip"
                                :title="gateway.rejection_reason"
                        ></i>
                    </span>
                            <span v-if="gateway.response_rejection_reason" class="position-absolute"
                                  style="cursor: pointer; color: orangered" data-toggle="dropdown">
                        <i class="fa fa-info-circle" aria-hidden="true" style="font-size: 1.6em;"></i>
                    </span>
                            <ul v-if="gateway.response_rejection_reason" class="dropdown-menu">
                                <div class="dropdown-header">{{ $t('gateway.btn.rejection_reason') }}</div>
                                <li v-bind:key="reason.index" v-for="reason in gateway.response_rejection_reason" class="text-center">
                                    {{ reason.fieldName }} {{ ' : '}} {{reason.codeExceptionValue}}
                                </li>
                            </ul>
                            <br>
                            <span v-if="gateway.status" :class="'d-block w-75 mx-auto mt-3 badge badge-' + typeVariant(gateway.gateway_type)">
                        {{ $t('label.gateway_type') + ": " + gatewayType(gateway.gateway_type) }}
                    </span>
                            <span v-if="gateway.status" class="d-block w-75 mx-auto mt-3 badge badge-secondary">
                        {{ $t('label.gateway_id') + ": " + gateway.sequence }}
                    </span>
                        </kt-panel-header-label>
                    </kt-panel-body>
                        <kt-row>
                            <kt-col>
                                <kt-panel-footer class="p-3 pr-1 text-center" style="padding-left: 0!important">
                                    <router-link class="btn btn-secondary border-0 w-100 bg-secondary text-dark btn-square"
                                                 :to="updateUrl(gateway.gateway_type) + gateway.id">
                                        {{ $t('btn.edit') }}
                                    </router-link>
                                </kt-panel-footer>
                            </kt-col>
                            <kt-col>
                                <kt-panel-footer class="p-3 pl-1 text-center" style="padding-right: 0!important">
                                    <router-link class="btn btn-secondary border-0 w-100 bg-secondary text-dark btn-square"
                                                 :to="allotmentUrl(gateway.gateway_type) +  gateway.id">
                                        {{ $t('btn.allotment') }}
                                    </router-link>
                                </kt-panel-footer>
                            </kt-col>
                    </kt-row>
                </kt-panel>
            </div>
            <div class="col col-sm-6 col-lg-4 col-xl-3">
                <kt-panel v-if="hasCartGateway">
                    <kt-panel-body class="p-0 pt-4">
                        <kt-panel-header-label class="text-center">
                            <kt-row>
                                <kt-col lg="12" md="12" sm="12" class="mb-mt-10">
                                    <img src="../assets/cart-gateway3.png"
                                         class="kt-badge kt-badge--square kt-badge--lg"/>
                                    <kt-panel-header-title class="mt-3 mb-3 text-dark">
                                        کارت به کارت
                                    </kt-panel-header-title>
                                    <span :class="'kt-badge--'+variant(gatewayStatus.ACTIVE)"
                                          class="kt-badge kt-badge--dot mr-1"
                                    >
                            </span>
                                    <span :class="'text-'+variant(gatewayStatus.ACTIVE)">
                                 {{ statusStr(gatewayStatus.ACTIVE) }}
                            </span>
                                    <span :class="'d-block w-75 mx-auto mt-3 badge badge-' + typeVariant(gatewayTypes.PAYMAN)">
                                {{ $t('label.gateway_type') + ": کارت به کارت" }}
                            </span>
                                </kt-col>
                            </kt-row>
                        </kt-panel-header-label>
                    </kt-panel-body>
                    <kt-row>
                        <kt-col class="text-center">
                            <kt-panel-footer class="pl-5 pr-5 pt-2 pb-2 ml-5 mr-5 mb-mt-8 text-center">
                                <button class="btn btn-secondary border-0 w-100 bg-secondary text-dark btn-square"
                                        @click="LoginToCardStar"
                                >
                                    {{ $t('btn.edit') }}
                                </button>
                            </kt-panel-footer>
                        </kt-col>
                    </kt-row>
                </kt-panel>
            </div>
        </kt-row>
        <div v-else>
            <loader></loader>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import {gatewayStatus, gatewayStatusStr, gatewayVariant} from '@/constants/gatewayStatus'
    import {gatewayTypes, gatewayTypeStr, gatewayTypeUpdateUrl, gatewayTypeVariant} from '@/constants/gatewayTypes'
    import $ from 'jquery'
    import Loading from '@/components/custom/loading'
    import {STAR_CARD_REGISTER} from "@/common/config";
    import {dedicatedService, gatewayService} from '@/common/api.service';

    export default {
        components: {
            'loader': Loading
        },
        data() {
            return {
                sign_key: '',
                gatewayStatus: gatewayStatus,
                gatewayTypes: gatewayTypes,
                login_cart_gateway: false
            }
        },
        methods: {
            ...mapActions('gateway', [
                'fetch'
            ]),
            copy(id) {
                let copiedLink = $('#sign_key' + String(id));
                copiedLink.select();
                document.execCommand("copy");
            },
            getSign(id, gateway_type) {
                if (gateway_type === gatewayTypes.PARDAKHTYARI) {
                    gatewayService.getSignKey(id).then((response) => {
                        this.sign_key = response.data.data.sign_key;
                    });
                } else if (gateway_type === gatewayTypes.DEDICATED) {
                    dedicatedService.getSignKey(id).then((response) => {
                        this.sign_key = response.data.data.sign_key;
                    });
                }
            },
            transactionLink(type) {
                switch (type) {
                    case gatewayTypes.PARDAKHTYARI:
                        return '/gateways/transactions-report/';
                    case gatewayTypes.DEDICATED:
                        return '/dedicated/transactions-report/';
                }
                return '#';
            },
            variant(status) {
                return gatewayVariant(status)
            },
            typeVariant(type) {
                return gatewayTypeVariant(type)
            },
            statusStr(status) {
                return gatewayStatusStr.get(status)
            },
            gatewayType(type) {
                return gatewayTypeStr.get(type)
            },
            updateUrl(type) {
                return gatewayTypeUpdateUrl(type)
            },
            getLink(hashid) {
                return "/profile/namad/" + hashid
            },

            getReportLink(hashid) {
                return "/gateways/transactions-report/" + hashid
            },

            LoginToCardStar() {
                this.login_cart_gateway = true

                var phone;
                var first_name;
                var last_name;
                if (Object.keys(this.current_user).length > 0) {
                    phone = this.current_user.phone
                    first_name = this.current_user.first_name
                    last_name = this.current_user.last_name
                } else {
                    this.$store.dispatch('user/fetchCurrent').finally(() => {
                        phone = this.current_user.phone
                        first_name = this.current_user.first_name
                        last_name = this.current_user.last_name
                    })
                }

                let form = document.createElement('form')

                let input_phone = document.createElement('input')
                input_phone.setAttribute('value', phone)
                input_phone.setAttribute('name', 'phone')

                let input_first_name = document.createElement('input')
                input_first_name.setAttribute('value', first_name)
                input_first_name.setAttribute('name', 'first_name')

                let input_last_name = document.createElement('input')
                input_last_name.setAttribute('value', last_name)
                input_last_name.setAttribute('name', 'last_name')

                form.appendChild(input_phone)
                form.appendChild(input_first_name)
                form.appendChild(input_last_name)
                form.setAttribute('action', STAR_CARD_REGISTER)
                form.setAttribute('method', 'POST')
                document.body.appendChild(form)
                form.setAttribute('style', 'display: none;');
                // this.login_cart_gateway = false
                form.submit()
            },
            allotmentUrl(type) {
                switch (type) {
                    case gatewayTypes.PARDAKHTYARI:
                        return '/gateways/stakeholders/';
                    case gatewayTypes.DEDICATED:
                        return '/dedicated/stakeholders/';
                }

                return '#';
            },
            statementLink(type) {
                switch (type) {
                    case gatewayTypes.PARDAKHTYARI:
                        return '/gateways/statements-report/';
                    case gatewayTypes.DEDICATED:
                        return '/dedicated/statements-report/';
                }
                return '#';
            },
        },

        mounted() {
            this.fetch(this.$route.path === '/starshop-gateways')
        },
        computed: {
            ...mapGetters('gateway', [
                'gateways',
                'hasCartGateway'
            ]),
            ...mapGetters('user', [
                'current_user'
            ]),
        },

    }
</script>

<style scoped>
    .show-report-status {
        margin-top: -25%;
    }

    .kt-badge--lg {
        height: 50px !important;
        width: 90px !important;
    }

    .mb-mt-10 {
        margin-top: 10px;
        margin-bottom: 10px;
    }

    .mb-mt-8 {
        margin-top: 8px;
        margin-bottom: 8px;
    }

    .routerLink {
        color: dodgerblue !important;
    }
</style>
